import Styles from './UserAssessments.module.scss';
import { useState, useContext, Fragment, useEffect } from 'react';

import {
    useNavigate, ViewContext,
    // AuthContext,
    useAPI, useParams
} from 'components/lib';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { MetricsCard } from '../UserMetrics/UserMetrics';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';

import FeatherIcon from 'feather-icons-react';
import { Pagination } from '@mui/material';

export function UserAssessments(props) {

    // const authContext = useContext(AuthContext)
    const viewContext = useContext(ViewContext)

    const { metricId } = useParams();
    const navigate = useNavigate()

    const { data, loading } = useAPI(`/api/user/metrics/${metricId}`)


    const handlePageChange = (event, pageNumber) => {
        console.log(pageNumber)
    };

    const [userAssessments, setUserAssessments] = useState()

    useEffect(() => {
        if (data?.assessments) {
            setUserAssessments(data?.assessments)
            document.title = `${data?.metricName}: ${props.t('QualityQuotient.UserAssessments.assessments')}`
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    const assessmentIcon = (percentage = 0, attempts, isMetricLocked) => {
        if (isMetricLocked) {
            return "Lock"
        }
        if (!attempts) {
            return "Circle"
        } else if (percentage < data?.range[0]) {
            return "AlertCircle"
        }
        return "CheckCircle"
    }

    return (
        <>
            <LoadingBackdrop isOpen={loading} />
            <div id='ancestorContainer' className={Styles.ancestorContainer}>
                <div id='mainHeader' className={Styles.mainHeader}>
                    <BreadCrumbs
                        onClickPaths={[
                            `/user/metrics`,
                            '',
                        ]}
                        crumbs={[
                            props.t('QualityQuotient.UserAssessments.breadcrumbs.first'),
                            `${data?.metricName ? data?.metricName + ":" : ""} ${props.t('QualityQuotient.UserAssessments.breadcrumbs.second')}`
                        ]}
                    />
                    <AivagamButton
                        type="confirm"
                        id="saveForm"
                        buttonText={
                            <>
                                <FeatherIcon
                                    color='white'
                                    icon='eye'
                                />
                                {props.t('QualityQuotient.UserAssessments.button.title')}
                            </>
                        }
                        onClick={() => navigate(`/user/metrics/${metricId}/report`)}
                        disabled={data?.lockReport ?? true}
                        icon
                        tooltipText={
                            data?.lockReport ?
                                props.t('QualityQuotient.UserAssessments.button.tooltip')
                                : null
                        }
                    />
                </div>
                <div id='paginationContainer' className={Styles.paginationContainer}>
                    <span>
                        {/* You can attempt any Assessment <strong>{data?.maxAttempts || "∞"}</strong> times. Your best score will be saved. */}
                        {props.t('QualityQuotient.UserAssessments.message', { times: `${data?.maxAttempts || "∞"}` })}
                    </span>
                    {/* {times: <strong>{data?.maxAttempts || "∞"}</strong>} */}
                    <Pagination
                        count={data?.pages}
                        color="primary"
                        onChange={handlePageChange}
                        size="small"
                        sx={{
                            maxWidth: "50%",
                            marginLeft: "auto",
                            width: "fit-content",
                            marginTop: "0.5em",
                        }}
                    />
                </div>
                <div id='assessmentsContainer' className={Styles.assessmentsContainer}>
                    {userAssessments?.map((assess, index) => (
                        <Fragment key={assess.id}>
                            <MetricsCard
                                metricsData={{
                                    ...assess,
                                    icon: assessmentIcon(assess?.percentage, assess?.attempts, data?.metricsStatus === "closed")
                                }}
                                configURL={`/metrics/${metricId}/assessment/${assess.id}`}
                                cardOnClick={() => {
                                    if (data?.metricsStatus !== "closed") {
                                        if (data?.maxAttempts && assess?.attempts >= data.maxAttempts) {
                                            viewContext.notification.show(
                                                props.t('QualityQuotient.UserAssessments.notification.exhaust'),
                                                "warning")
                                        } else {
                                            navigate(`/user/assessment/${assess.id}/attempt`)
                                        }
                                    } else {
                                        viewContext.notification.show(
                                            props.t('QualityQuotient.UserAssessments.notification.locked'),
                                            "warning")
                                    }
                                }}
                            />
                        </Fragment>
                    ))}
                </div>
            </div>
        </>
    );
}